"use client"

import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { useFetchRefinements } from "../../hooks/DataFetching/useFetchRefinements";
import { Sparkles } from "lucide-react";

const RefinementList = ({ groupId }) => {
  const { items, loading, error } = useFetchRefinements(groupId);

  if (loading) return <div className="group-inline-state">Loading refinements...</div>;
  if (error) return <div className="group-error-state">{error}</div>;

  if (!items.length) return <div className="group-empty-state">No items in refinement.</div>;

  const getPath = (type, id) => {
    switch (type.toLowerCase()) {
      case "action":
        return `/actions/${id}/refinement`;
      case "policy":
        return `/policies/${id}/refinement`;
      case "position":
        return `/positions/${id}/refinement`;
      case "calendarevent":
        return `/events/${id}/refinement`;
      default:
        return null;
    }
  };

  return (
    <div className="group-nested-panel">
      <div className="group-section-heading">
        <span className="group-section-kicker"><Sparkles className="h-4 w-4" /> Refinement queue</span>
        <h3>Items in refinement</h3>
        <p>Open an item to improve the approved idea with the Refinement Guide. Talk through what is missing, review the Guide’s draft, and choose when to post it for the group.</p>
      </div>
      <div className="group-list-stack">
      {items.map((item) => {
        const path = getPath(item.type, item.id);
        return (
          <div key={`${item.type}-${item.id}`} className="group-refinement-row">
            <span><strong>{item.type}</strong>: {item.title}</span>
            {path && (
              <Link to={path}>
                <Button size="sm" className="group-ui-button">Refine</Button>
              </Link>
            )}
          </div>
        );
      })}
      </div>
    </div>
  );
};

export default RefinementList;

